module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-vehicles"
  }, [_c('p', [_vm._v("You have no " + _vm._s(_vm.vehiclesCategory) + " vehicles")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "inventory"
    }
  }, [_vm._v("Shop here")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-607fe0f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-607fe0f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/garage/no-vehicles.vue
// module id = 838
// module chunks = 0